import { render, staticRenderFns } from "./PaymentAttachments.vue?vue&type=template&id=3bca7765&scoped=true"
import script from "./PaymentAttachments.vue?vue&type=script&lang=js"
export * from "./PaymentAttachments.vue?vue&type=script&lang=js"
import style0 from "./PaymentAttachments.vue?vue&type=style&index=0&id=3bca7765&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca7765",
  null
  
)

export default component.exports